import styled from 'styled-components'

export const QuestionModalWrapper = styled.div<{ hideFooter: boolean }>`
  display: flex;
  flex-wrap: wrap;

  h1,
  p {
    padding: 0;
    margin: 0;
  }

  h1,
  p {
    width: calc(100% - ${props => props.theme.spacing.medium});
  }

  & > div {
    width: 100%;
  }

  h1 {
    font-size: ${props => props.theme.font.medium};
    margin-bottom: ${props => props.theme.spacing.medium};
  }

  p {
    font-size: ${props => props.theme.font.small};
  }

  & > div {
    margin-top: ${props => props.theme.spacing.medium};

    &:last-of-type {
      display: ${props => (props?.hideFooter ? 'none' : 'flex')} !important;
      align-items: center;

      & > button:first-child {
        margin-right: ${props => props.theme.spacing.medium};
      }
    }
  }
`
